import { CheckCircleIcon } from "@heroicons/react/24/outline";
import React from "react";
import Modal from "./Modal";
import { useRecoilValue } from "recoil";
import { billingAtom } from "../store/billingAtom";

const getPeriod = selectedPlan => {
  if (selectedPlan?.type === "annually") return "year";
  else if (selectedPlan?.type === "monthly") return "month";
  return "N/A";
};

export default function RenewPlanModal({
  open,
  onClose,
  onSubmit,
  loading,
  selectedPlan,
}) {
  const billingInfo = useRecoilValue(billingAtom);
  
  const period = getPeriod(selectedPlan);

  return (
    <Modal
      title="Renew Subscription"
      description={
        <div>
          <p>
            By clicking <span className="font-semibold">Renew</span>, you will
            re-initiate your subscription to the{" "}
            <span className="font-semibold">
              {selectedPlan?.name || "N/A"} plan
            </span>{" "}
            for ${selectedPlan?.cost || "N/A"} per {period}.
          </p>

          <p>
            You will not be charged until your plan renews on{" "}
            <span>{billingInfo?.next_renewal || "N/A"}</span>.
          </p>
        </div>
      }
      open={open}
      onClose={onClose}
      onSubmit={onSubmit}
      isSubmitting={loading}
      startIcon={
        <CheckCircleIcon aria-hidden="true" className="size-8 text-green-600" />
      }
    />
  );
}
